import { render } from "./MatriculasV2Handoff.vue?vue&type=template&id=c845f72e&scoped=true"
import script from "./MatriculasV2Handoff.vue?vue&type=script&lang=js"
export * from "./MatriculasV2Handoff.vue?vue&type=script&lang=js"

import "./MatriculasV2Handoff.vue?vue&type=style&index=0&id=c845f72e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c845f72e"]])

export default __exports__